import { render } from "./AxonHero.vue?vue&type=template&id=51176ab0&scoped=true"
import script from "./AxonHero.vue?vue&type=script&lang=js"
export * from "./AxonHero.vue?vue&type=script&lang=js"

import "./AxonHero.vue?vue&type=style&index=0&id=51176ab0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51176ab0"]])

export default __exports__